import type { InvestmentsFeatures } from '../types';

export const features: InvestmentsFeatures = {
    enabled: false,
    _description: 'Enables investments as a whole for the user. It is disabled by default.',
    digiVV: {
        enabled: true,
        _description:
            'Enables the functionality of digiVV invest manager for the user. It is disabled by default.',
    },
    export: {
        enabled: true,
        _description:
            'Enables the export functionality for the user. It allows the user to export reports in different formats. It is disabled by default.',
    },
    externalPlatform: {
        enabled: false,
        _description:
            'Enables the functionality of using an external trading system for the user. It is disabled by default.',
    },
    gainloss: {
        enabled: true,
        _description:
            'Enables the functionality to display the gain loss link in the securities overview page. It is disabled by default.',
    },
    watchlist: {
        enabled: true,
        _description:
            'Enables the new Watchlist functionality for the user. It is disabled by default.',
    },
    priceAlerts: {
        enabled: true,
        _description:
            'Enables the new Price Alerts functionality for the user. It is disabled by default.',
    },
    marketDataPortal: {
        enabled: true,
        _description: 'Enables the button as an entry point for the market data portal.',
    },
    advertisement: {
        enabled: false,
        _description:
            'Enables the display of the investment advertisement cards on the overview page.',
    },
    appropriatenessTest: {
        enabled: false,
        _description:
            'Enables the launch of the appropriateness test in the order form V3. It is disabled by default.',
    },
    statements: {
        enabled: true,
        _description: 'Enables the securities statements feature. It is disabled by default.',
    },
    statementsDownloadCurrentLanguage: {
        enabled: false,
    },
    buyLinkTarget: {
        enabled: false,
        _description: 'Enables the buy button target for MIO feature. It is disabled by default.',
    },
    pip: {
        enabled: false,
        _description: 'Enables the personal plan flow. It is disabled by default.',
    },
    pipAdvisory: {
        enabled: false,
        _description: 'Enables the personal plan advisory flow. It is disabled by default.',
    },
    pipPriceMod: {
        enabled: false,
    },
    standaloneSecuritiesAccountOpeningFlow: {
        enabled: false,
        _description: 'Enables the standalone portfolio creation page',
    },
    investmentPlans: {
        enabled: false,
        _description: 'Enables the investment plans page',
    },
    orders: {
        enabled: true,
        _description:
            'Enables the securities orders functionality for the user. It is disabled by default.',
    },
    overviewPerformance: {
        enabled: false,
        _description:
            'Enables the performance functionality for the user. It allows the user to see the performance section in the overview page. It is disabled by default.',
    },
    privateBanking: {
        enabled: true,
        _description:
            'Enables the private banking section for the user where he can see all his reports. It is disabled by default.',
    },
    profile: {
        enabled: false,
        _description:
            'Enables the securities profile functionality for the user. It allows the user to activate trading and update his knowledge and experience about trading.',
    },
    regularOrders: {
        enabled: false,
        _description:
            'Enables the regular investments functionality for the user. It allows the user to access the list of regular investments and manage the orders. It is disabled by default.',
    },
    sfondsplan: {
        enabled: true,
        _description:
            'Enables the S Fonds Plan/Investment Plans functionality for the user. It allows the user to open a new investment plan and manage their existing ones. It is disabled by default.',
    },
    trading: {
        enabled: true,
        _description:
            'Enables the trading functionality for the user. It allows the user to trade products using the order form. It is disabled by default.',
    },
    junior: {
        enabled: false,
    },
    fundamentalsData: {
        enabled: false,
    },
    accDetailV2: {
        enabled: false,
    },
    changePrice: {
        enabled: false,
        _description: 'Enables the portfolio model migration card on portfolio settings.',
    },
};
